// Port of api/fuel/app/classes/filter/search/games/filters/query/game/language/dependency.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'game.language.dependency',
	priority: 48,
	require: function(config, filter) {
		return rangeActive(filter.language && filter.language.dependency, 1, 5)
	},
	run: function(config, filter, data, query) {
		query.where('g.game_language_dependency', '>=', filter.language.dependency.from)
		query.where('g.game_language_dependency', '<=', filter.language.dependency.to)
	}
}
